/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StructureDamageEntry } from './structureDamageEntry';
import { StructureDamageSeverityHistory } from './structureDamageSeverityHistory';


/**
 * damage
 */
export interface StructureDamage { 
    /**
     * primary Key
     */
    id?: number;
    /**
     * Structure id
     */
    structureId?: number;
    /**
     * flag if the damage is still existing
     */
    isCurrent?: boolean;
    /**
     * flag if the damage is fixed
     */
    isClosed?: boolean;
    /**
     * On this date the damage was first noted
     */
    firstOccurenceDatetime?: string;
    /**
     * On this date the damage was last noted
     */
    lastOccurenceDatetime?: string;
    /**
     * categories
     */
    categories?: string;
    /**
     * textProperties
     */
    textProperties?: string;
    /**
     * numericProperties
     */
    extUrls?: string;
    structureDamageSeverityHistories?: Array<StructureDamageSeverityHistory>;
    structureDamageEntry?: Array<StructureDamageEntry>;
}

